import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "absolute top-5 right-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", { class: "mr-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1040_5920)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M10.0001 13.3334V10.0001M10.0001 6.66675H10.0084M18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001C1.66675 5.39771 5.39771 1.66675 10.0001 1.66675C14.6025 1.66675 18.3334 5.39771 18.3334 10.0001Z",
        stroke: "#98A2B3",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1040_5920" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_4 = { class: "absolute z-10 p-2 shadow-sm bg-[#101828] text-sm text-white p-3 top-0 -left-[305px] rounded-md w-[300px]" }
const _hoisted_5 = { class: "flex items-start justify-between w-full p-6" }
const _hoisted_6 = { class: "flex items-start flex-row" }
const _hoisted_7 = { class: "mb-1 text-[#101828] font-semibold text-lg mr-3" }
const _hoisted_8 = { class: "border border-[EE9D7FE] bg-[#F9F5FF] rounded-full py-0.5 px-2 text-[#155EEF] font-medium text-xs mt-1" }
const _hoisted_9 = { class: "flex justify-start items-center gap-2 rounded-full border border-[#EAECF0] p-1 inline-flex mr-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = { class: "w-full text-left" }
const _hoisted_12 = { class: "text-xs text-[#475467] font-medium pl-6 py-3 border-b border-b-[#EAECF0]" }
const _hoisted_13 = { class: "text-xs text-[#475467] font-medium py-3 border-b border-b-[#EAECF0]" }
const _hoisted_14 = { class: "text-xs text-[#475467] font-medium pr-6 py-3 border-b border-b-[#EAECF0]" }
const _hoisted_15 = { class: "text-[#101828] font-sm font-medium pl-6 py-6 border-b border-b-[#EAECF0]" }
const _hoisted_16 = { class: "text-sm text-[#475467] py-6 border-b border-b-[#EAECF0]" }
const _hoisted_17 = { class: "flex flex-row gap-3 items-center pr-6 py-6 border-b border-b-[#EAECF0]" }
const _hoisted_18 = { class: "bg-[#EAECF0] rounded-full h-[8px] min-w-36 w-full" }
const _hoisted_19 = { class: "text-[#344054] font-sm font-medium" }
const _hoisted_20 = { class: "flex justify-between items-center mt-3 mb-4 px-6" }
const _hoisted_21 = { class: "text-[#344054] text-sm font-medium" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]

import { useActivityStore } from "@/stores/activityStore";
import { ref, computed } from "vue";
import { useSchoolStore } from "@/stores/schoolStore";

import FiltersOutOfDateComponent from "@/modules/main/components/FiltersOutOfDateComponent.vue";
import LoadingSpinnerComponent from "@/modules/main/components/LoadingSpinnerComponent.vue";

const itemsPerPage = 7;


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivitySummaryPerClassComponent',
  setup(__props) {

const activityStore = useActivityStore();
const schoolStore = useSchoolStore();

const classList = computed(
  () =>
    schoolStore?.currentSchoolStructure?.classGroups.map((classGroup) => ({
      name: classGroup.name,
      _id: classGroup._id,
    })) as unknown as any[]
);

const summaryData = computed(() => {
  return activityStore?.getActivitySummaryPerClassData as unknown as any[];
});

// Map the summaryData object to display the data
const mappedData = computed(() => {
  if (summaryData.value) {
    return summaryData.value.map((item) => {
      // Find the matching class group based on _id
      const matchingClassGroup = classList.value.find(
        (classGroup) => classGroup._id === item.classGroupId
      );
      return {
        classGroupId: item.classGroupId,
        className: matchingClassGroup ? matchingClassGroup.name : "Unknown", // Return the name or 'Unknown' if no match
        averageLearningTimeMonth: Math.floor(item.averageLearningTimeMonth),
        averageLearningTimeWeek: Math.floor(item.averageLearningTimeWeek),
        percentageDailyTasksCompletionMonth:
          item.percentageDailyTasksCompletionMonth,
        percentageDailyTasksCompletionWeek:
          item.percentageDailyTasksCompletionWeek,
      };
    });
  } else {
    return [];
  }
});

const selectedActivity = ref("Last 30 days");
const currentPage = ref(1);
const activeActivity = ref(
  "border border-[#EAECF0] rounded-full text-sm py-2.5 px-5 font-semibold text-[#344054]"
);

const inactiveActivity = ref(
  "py-2.5 px-5 border-transparent rounded-full text-sm font-semibold text-[#667085]"
);

const classCount = computed(
  () => activityStore?.activitySummaryPerClassData?.length
);

// Calculate total pages based on the items per page
const totalPages = computed(() => {
  return Math.ceil(mappedData.value.length / itemsPerPage);
});

// Get the data for the current page
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return mappedData.value.slice(start, end);
});

function prevPage() {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
}
// Go to the next page
function nextPage() {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
}

// Generate progress bar background for activity cards
const generateColoursFromPercentage = (percentage: number) => {
  if (percentage === 0) {
    return "bg-[#EAECF0]";
  }

  // Red Color
  if (percentage <= 33) {
    return "bg-[#FDA29B]";
  }

  // Yellow Color
  if (percentage > 33 && percentage <= 66) {
    return "bg-[#FEC84B]";
  }

  // Green Color
  if (percentage > 66) {
    return "bg-[#ABEFC6]";
  }
};

return (_ctx: any,_cache: any) => {
  const _component_tooltip = _resolveComponent("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingSpinnerComponent),
    _createVNode(FiltersOutOfDateComponent),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_tooltip, null, {
        trigger: _withCtx(() => [
          _hoisted_3
        ]),
        tooltip: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("activity_view.tooltips.activity_summary_class")), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.header")), 1)
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(classCount.value) + " " + _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.classes")), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedActivity.value = 'Last 30 days')),
          class: _normalizeClass(
            (selectedActivity.value === 'Last 30 days'
              ? activeActivity.value
              : inactiveActivity.value) + ' px-2'
          )
        }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.last_30_days")), 3),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedActivity.value = 'Last 7 days')),
          class: _normalizeClass(
            (selectedActivity.value === 'Last 7 days'
              ? activeActivity.value
              : inactiveActivity.value) + ' px-2'
          )
        }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.last_7_days")), 3)
      ])
    ]),
    _hoisted_10,
    _createElementVNode("table", _hoisted_11, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.class")), 1),
        _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.average_minutes")), 1),
        _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.daily_tasks")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedData.value, (data, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          _createElementVNode("td", _hoisted_15, _toDisplayString(data.className), 1),
          _createElementVNode("td", _hoisted_16, _toDisplayString(selectedActivity.value === "Last 30 days"
              ? Math.floor(data.averageLearningTimeMonth / 60)
              : Math.floor(data.averageLearningTimeWeek / 60)) + " " + _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.min")), 1),
          _createElementVNode("td", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", {
                class: _normalizeClass(
                generateColoursFromPercentage(
                  Math.min(
                    Number(
                      selectedActivity.value === 'Last 30 days'
                        ? data.percentageDailyTasksCompletionMonth
                        : data.percentageDailyTasksCompletionWeek
                    ),
                    100
                  )
                ) + ' h-[8px] rounded-full'
              ),
                style: _normalizeStyle(
                'width: ' +
                (selectedActivity.value === 'Last 30 days'
                  ? data.percentageDailyTasksCompletionMonth
                  : data.percentageDailyTasksCompletionWeek) +
                '%'
              )
              }, null, 6)
            ]),
            _createElementVNode("span", _hoisted_19, _toDisplayString(selectedActivity.value === "Last 30 days"
                ? data.percentageDailyTasksCompletionMonth.toFixed(0)
                : data.percentageDailyTasksCompletionWeek.toFixed(0)) + "% ", 1)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.page")) + " " + _toDisplayString(currentPage.value) + " " + _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.of")) + " " + _toDisplayString(totalPages.value), 1),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          onClick: prevPage,
          disabled: currentPage.value === 1,
          class: "text-[#344054] text-sm font-semibold border border-[#D0D5DD] px-3 py-2 bg-white rounded-lg disabled:opacity-50 mr-3"
        }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.previous")), 9, _hoisted_22),
        _createElementVNode("button", {
          onClick: nextPage,
          disabled: currentPage.value === totalPages.value,
          class: "text-[#344054] text-sm font-semibold border border-[#D0D5DD] px-3 py-2 bg-white rounded-lg disabled:opacity-50"
        }, _toDisplayString(_ctx.$t("activity_view.activity_summary_per_class_card.next")), 9, _hoisted_23)
      ])
    ])
  ]))
}
}

})